import * as actionTypes from './actionTypes';
import {getData} from "../../shared/networkUtil";

export const getProductsRequest = () => ({
    type: actionTypes.GET_PRODUCTS_REQUEST
});

export const getProductsSuccess = products => ({
    type: actionTypes.GET_PRODUCTS_SUCCESS,
    products
});

export const getProductsError = error => ({
    type: actionTypes.GET_PRODUCTS_ERROR,
    error
});

export const getProducts = () => dispatch => {
    dispatch(getProductsRequest());
    getData(
        "/product-groups",
        response => {
            console.log(response);
            dispatch(getProductsSuccess(response.data));
        },
        error => {
            console.log(error);
            dispatch(getProductsError(error));
        }
    );
};
